import { useEffect } from "react";
import Question from "./question.template";
import { isQuestionAnswered } from "../../utils/generalFormUtils";

const FormPage = ({
  questions = [],
  answers = {},
  onAnswerChange,
  setSubmitEnabled,
}) => {
  useEffect(() => {
    const allAnswered = questions.every((q) => {
      const isAnswered = isQuestionAnswered(q, answers[q.id]);
      return isAnswered;
    });

    setSubmitEnabled(allAnswered);
  }, [answers, questions, setSubmitEnabled]);

  return (
    <div style={styles.container}>
      {questions.length === 0 ? (
        <div style={styles.emptyState}>
          <p>No hay preguntas disponibles para esta página.</p>
          <p>Preguntas recibidas: {questions.length}</p>
        </div>
      ) : (
        <div style={styles.questionsContainer}>
          {questions.map((q, index) => {
            const isAnswered = isQuestionAnswered(q, answers[q.id]);
            return (
              <div key={q.id} style={styles.questionWrapper}>
                <Question
                  question={q}
                  answer={answers[q.id] || ""}
                  onAnswerChange={(value) => {
                    onAnswerChange(q.id, value);
                  }}
                />
                {isAnswered && (
                  <div style={styles.answeredIndicator}>✓ Respondida</div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  emptyState: {
    padding: "2rem",
    textAlign: "center",
    color: "#666",
  },

  questionsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  questionWrapper: {
    position: "relative",
    padding: "16px",
    border: "1px solid #e9ecef",
    borderRadius: "8px",
    backgroundColor: "#fff",
  },
  answeredIndicator: {
    position: "absolute",
    top: "8px",
    right: "8px",
    fontSize: "12px",
    color: "#28a745",
    backgroundColor: "#d4edda",
    padding: "2px 6px",
    borderRadius: "4px",
    fontWeight: "500",
  },
};

export default FormPage;
